import { ReactElement } from 'react';

import { ModalCancelButton, ModalCloseButton } from '@dreryk/react-components';

import { AdamedExpertAuthenticateForm } from './AdamedExpertAuthenticateForm';
import { AdamedExpertAuthenticateModalConfirmButton } from './AdamedExpertAuthenticateModalConfirmButton';
import { AdamedExpertAuthenticateModalLoader } from './AdamedExpertAuthenticateModal.loader';

type AdamedExpertAuthenticateModalProps = {
   onClose: VoidFunction;
};

export const AdamedExpertAuthenticateModalContent = (props: AdamedExpertAuthenticateModalProps): ReactElement => {
   return (
      <AdamedExpertAuthenticateModalLoader>
         {({ integrationProfile }) => (
            <AdamedExpertAuthenticateForm integrationProfile={integrationProfile}>
               {({ handleSubmit, formState }) => (
                  <>
                     <AdamedExpertAuthenticateModalConfirmButton
                        onSuccess={props.onClose}
                        handleSubmit={handleSubmit}
                     />
                     <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
            </AdamedExpertAuthenticateForm>
         )}
      </AdamedExpertAuthenticateModalLoader>
   );
};
